export const setAccessToken = (token: string, expiresIn: number) => {
  const expiresAt = new Date(Date.now() + expiresIn * 1000).toISOString();
  localStorage.setItem("access_token", token);
  localStorage.setItem("access_token_expires_at", expiresAt);
};

export const getAccessToken = () => {
  const token = localStorage.getItem("access_token");
  const expiresAt = localStorage.getItem("access_token_expires_at");

  if (!token || !expiresAt || new Date(expiresAt) < new Date()) {
    return null;
  }
  return token;
};

export const getAccessTokenExpiry = () => {
  const expiresAt = localStorage.getItem("access_token_expires_at");
  return expiresAt ? new Date(expiresAt) : null;
};

export const setRefreshToken = (token: string, expiresIn: number) => {
  const expiresAt = new Date(Date.now() + expiresIn * 1000).toISOString();
  localStorage.setItem("refresh_token", token);
  localStorage.setItem("refresh_token_expires_at", expiresAt);
};

export const getRefreshToken = () => {
  const expiresAt = localStorage.getItem("refresh_token_expires_at");

  if (expiresAt && new Date(expiresAt) < new Date()) {
    clearTokens();
    return null;
  }
  return localStorage.getItem("refresh_token");
};

export const getRefreshTokenExpiry = () => {
  const expiresAt = localStorage.getItem("refresh_token_expires_at");
  return expiresAt ? new Date(expiresAt) : null;
};

export const clearTokens = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("refresh_token_expires_at");
  localStorage.removeItem("access_token_expires_at");
};

export const logout = () => {
  clearTokens();
  window.location.href = "/auth/sign-in";
};
